/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {LocalUserProfile} from '../../../components/session/local-user-profile';
import {Uuid} from '../../../components/util/uuid';
import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {AdminObjectState, SignalAdminResourceApiBase, SignalAdminResourcePage} from '../../common/controller/signal-admin-resource-api';

export interface NotificationPreferencesModel {
  id: string;
  user?: {id: string};
  subscriptions?: Record<string, any>;
  overrides?: Record<string, string[]>;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class NotificationPreferencesApiService extends SignalAdminResourceApiBase<NotificationPreferencesModel> {
  constructor(
    client: AdnApiClientService,
    private readonly localUserProfile: LocalUserProfile
  ) {
    super(client, 'notificationpreferences');
  }

  getCurrent(): Observable<NotificationPreferencesModel> {
    const userId = this.localUserProfile.get('userId');
    return this.client.request<SignalAdminResourcePage<NotificationPreferencesModel> | NotificationPreferencesModel | null>({
      method: 'GET',
      url: this.resourceUri('notificationpreferences'),
      params: {user: userId, orderBy: 'userId'}
    }).pipe(
      map((response) => {
        const pageModel = (response as SignalAdminResourcePage<NotificationPreferencesModel> | null)?.results?.[0];
        const directModel = response && 'id' in response ? response as NotificationPreferencesModel : null;
        return pageModel || directModel || {
          id: Uuid.generate(),
          user: {id: userId},
          objectState: 'ACTIVE',
          validationWarnings: []
        };
      })
    );
  }
}
